import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/nft-new/banner_nft.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner nft_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={8} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Best NFT Development Services in USA
              </h1>
              <span>End-to-end NFT Transaction Platform Development</span>
              <p>
                TekRevol specializes in building blockchain ecosystems for
                creating and managing NFTs. We ensure transparent asset
                provenance by tokenizing digital and physical assets. We
                facilitate the seamless tokenization of both digital and
                physical assets following the latest blockchain protocols to
                unlock new revenue streams for businesses.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Contact Us
              </Link>
              <Link
                to="/contact"
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
              >
                Get a Quote
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
